import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'smallValidation-message',
    template: `<p
    class="ir-required th-required"
    [hidden]="!(validationControl.hasError(validationName) && validationControl.touched)"
  >
    <span>{{ errorMessage }}</span>
  </p>`,
    standalone: false
})
export class SmallValidationMessageComponent {
  @Input() validationControl: AbstractControl;
  @Input() validationName: string = '';
  @Input() errorMessage: string = '';
}
